import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import { formatDateToMMDDYY } from '../../../utils/helpers';

const SurveyDetailsModal = ({
  open,
  onClose,
  survey
}) => {
  const getFormattedResponses = () => {
    const responses = [];
    if (!survey?.form_data) return responses;

    Object.entries(survey.form_data).forEach(([key, data]) => {
      responses.push({
        question: data.question,
        value: data.value,
        isScore: !isNaN(data.value)
      });
    });

    // Sort to show scores first, then text responses
    return responses.sort((a, b) => {
      if (a.isScore === b.isScore) return 0;
      return a.isScore ? -1 : 1;
    });
  };

  const getSurveyTypeName = (formType) => {
    switch (formType) {
      case 'naltrexoneGroupSurvey':
        return 'Naltrexone Group Survey';
      case 'ketamineGroupPreparationSurvey':
        return 'Ketamine Preparation Survey';
      case 'ketamineGroupIntegrationSurvey':
        return 'Ketamine Integration Survey';
      default:
        return formType;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h5" component="div">
          {getSurveyTypeName(survey?.form_name)}
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          Submitted: {formatDateToMMDDYY(survey?.created_at)}
          {survey?.email && ` | Email: ${survey.email}`}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {getFormattedResponses().map((response, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                {response.question}
              </Typography>
              <Typography 
                variant={response.isScore ? "h6" : "body1"}
                color={response.isScore ? "primary" : "textPrimary"}
              >
                {response.value}
                {response.isScore && "/5"}
              </Typography>
              {index < getFormattedResponses().length - 1 && (
                <Divider sx={{ mt: 2 }} />
              )}
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

SurveyDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  survey: PropTypes.object
};

export default SurveyDetailsModal; 